'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Map
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.Map = T.createModule({

	_selectors: {
		markerContent: '.js-map__marker',
		mapContainer: '.js-map__map-inner',
		infoBoxContent: '.js-map__template-info-box'
	},

	_stateClasses: {
		markerMouseOver: 'state-marker-mouseover',
		markerActive: 'state-marker-active'
	},

	_eventNames: {
		filterMapData: 'm-filter-map-data'
	},

	renderType: {
		replace: 'replace',
		append: 'append'
	},

	customMapStyles: [{
		'featureType': 'all',
		'elementType': 'geometry',
		'stylers': [{
			'color': '#d8d8d8'
		}]
	}, {
		'featureType': 'all',
		'elementType': 'labels.text.fill',
		'stylers': [{
			'color': '#616161'
		}]
	}, {
		'featureType': 'all',
		'elementType': 'labels.text.stroke',
		'stylers': [{
			'visibility': 'on'
		}, {
			'color': '#f5f5f5'
		}]
	}, {
		'featureType': 'all',
		'elementType': 'labels.icon',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'administrative',
		'elementType': 'geometry',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'administrative.country',
		'elementType': 'geometry.fill',
		'stylers': [{
			'color': '#919191'
		}]
	}, {
		'featureType': 'administrative.country',
		'elementType': 'geometry.stroke',
		'stylers': [{
			'visibility': 'on'
		}, {
			'color': '#919191'
		}]
	}, {
		'featureType': 'administrative.neighborhood',
		'elementType': 'all',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'administrative.land_parcel',
		'elementType': 'all',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'poi',
		'elementType': 'all',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'road',
		'elementType': 'geometry',
		'stylers': [{
			'color': '#ffffff'
		}]
	}, {
		'featureType': 'road',
		'elementType': 'labels.text.fill',
		'stylers': [{
			'color': '#757575'
		}]
	}, {
		'featureType': 'road',
		'elementType': 'labels.icon',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'road.highway',
		'elementType': 'geometry',
		'stylers': [{
			'color': '#dadada'
		}]
	}, {
		'featureType': 'road.highway',
		'elementType': 'geometry.fill',
		'stylers': [{
			'color': '#ffffff'
		}]
	}, {
		'featureType': 'road.highway',
		'elementType': 'geometry.stroke',
		'stylers': [{
			'color': '#ffffff'
		}, {
			'weight': 0.2
		}]
	}, {
		'featureType': 'road.highway',
		'elementType': 'labels.text.fill',
		'stylers': [{
			'color': '#616161'
		}]
	}, {
		'featureType': 'road.arterial',
		'elementType': 'geometry',
		'stylers': [{
			'color': '#ffffff'
		}]
	}, {
		'featureType': 'road.local',
		'elementType': 'geometry',
		'stylers': [{
			'color': '#ffffff'
		}]
	}, {
		'featureType': 'road.local',
		'elementType': 'labels.text.fill',
		'stylers': [{
			'color': '#9e9e9e'
		}]
	}, {
		'featureType': 'transit',
		'elementType': 'all',
		'stylers': [{
			'visibility': 'off'
		}]
	}, {
		'featureType': 'water',
		'elementType': 'geometry',
		'stylers': [{
			'color': '#ffffff'
		}]
	}, {
		'featureType': 'water',
		'elementType': 'labels.text.fill',
		'stylers': [{
			'color': '#9e9e9e'
		}]
	}],

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this.google = window.google;
		this.googleMaps = null;
		this.markerClusterer = null;
		this.mapClickListener = null;
		this.activeMarker = null;
		this.infoBox = null;
		this.addresses = [];
		this.locations = [];
		this.markers = [];
		this.apiKey = this.$ctx.data('api-key');
		this.language = this.$ctx.data('map-language');

		this.moduleOptions = {
			initialZoomLevel: 2,
			minimalZoomLevel: 2,
			initialCenter: {
				lat: 54.5260,
				lng: 15.2551
			},
			bounds: null,
			center: null,
			zoomLevel: 2,
			showAllMarkers: true
		};

		this.mapOptions = {
			streetViewControl: false,
			mapTypeControl: false
		};

		this.clustererOptions = {
			ignoreHidden: true,
			minimumClusterSize: 3,
			clusterClass: 'm-map__marker-clusterer'
		};

		// needs to be an array of style objects
		this.clustererIconStyles = [{
			fontFamily: 'R-Frutiger',
			height: 40,
			width: 40,
			anchor: [0, 0],
			textColor: '#fff',
			textSize: 20
		}];

		this.infoBoxWidth = 300;
		this.infoBoxOffset = 20;
		this.markerHeight = 36;

		this.clusteringIconUrl = '/assets/img/gmaps-clustering-icon.svg';

		// cluster icon is needed by the library but we hide it to be able to have a hover effect
		this.clustererIconStyles[0].url = this.clusteringIconUrl;

		$.extend(this.clustererOptions, {
			styles: this.clustererIconStyles
		});

		// check if google is already available on the window
		if (_typeof(this.google) === 'object') {
			this.googleMaps = this.google.maps;
		}

		this.$markerContent = this.$ctx.find(this._selectors.markerContent);
		this.$mapContainer = this.$ctx.find(this._selectors.mapContainer);

		// eslint-disable-next-line no-undef
		this.infoBoxTemplate = doT.template(this.$ctx.find(this._selectors.infoBoxContent).html());

		this.addresses = this.$ctx.data('addresses');
		this.locations = [];

		if (this.addresses.length > 0) {
			this.locations = this.addresses;
		}

		// eslint-disable-next-line max-len
		this.googleMapsApiUrl = '//maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&v=3.34&callback=onGoogleMapsApiLoaded&language=' + this.language;
		this.richMarkerLibraryUrl = '/assets/vendor/richmarker.min.js';
		this.infoBoxLibraryUrl = '/assets/vendor/infobox.min.js';
		this.markerClustererLibraryUrl = '/assets/vendor/markerclusterer.min.js';

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		this._events.on(this._eventNames.filterMapData, this.onFilterMapData.bind(this));

		this.hasBeenInitialized = false;

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {
		if (!this.hasBeenInitialized && this.addresses.length > 0) {
			this.initialize();

			this.hasBeenInitialized = true;
		}
	},


	/**
  * Add the marker events for the given marker
  *
  * @param {Object} marker The marker to add the events to
  * @returns {void}
  */
	addMarkerEvents: function addMarkerEvents(marker) {
		var mod = this; // eslint-disable-line consistent-this

		marker.addListener('mouseover', function () {
			mod.toggleMapMarkerMouseOverClass(marker);
		});

		marker.addListener('mouseout', function () {
			mod.toggleMapMarkerMouseOverClass(marker);
		});

		marker.addListener('click', function () {
			mod.onClickLocationMarker(marker);
		});
	},


	/**
  * Check if all functions exist on the window, some libraries need a little time until they are initialized
  *
  * @param {Array} functionsToCheck The functions to check
  * @returns {Promise} A promise which get's resolved when all the provided functions exist on the window
  */
	checkForFunctionExistence: function checkForFunctionExistence(functionsToCheck) {
		var _this = this;

		return this.librariesLoadedPromise.then(function () {
			return new Promise(function (resolve) {
				var allFunctionsExist = true;

				$.each(functionsToCheck, function (index, functionToCheck) {
					if (typeof window[functionToCheck] !== 'function') {
						allFunctionsExist = false;
					}
				});

				if (allFunctionsExist) {
					resolve();
				} else {
					window.setTimeout(function () {
						_this.checkForFunctionExistence(functionsToCheck);
					}, 50);
				}
			});
		});
	},


	/**
  * Close the infoBox which is currently open, remove map click listener and toggle active class
  *
  * @returns {void}
  */
	closeInfoBox: function closeInfoBox() {
		if (this.infoBox !== null) {
			this.infoBox.close();

			this.toggleMapMarkerActiveClass(this.activeMarker);

			this.infoBox = null;
			this.googleMaps.event.removeListener(this.mapClickListener);
		}
	},


	/**
  * Destroy all markers on the map
  *
  * @returns {void}
  */
	destroyMarkers: function destroyMarkers() {
		var mod = this; // eslint-disable-line consistent-this

		$.each(this.markers, function (index, marker) {
			mod.googleMaps.event.clearInstanceListeners(marker);
			marker.setMap(null);
		});

		if (this.markerClusterer !== null) {
			this.markerClusterer.clearMarkers();
		}

		this.moduleOptions.bounds = null;

		this.markers = [];
	},


	/**
  * Handle the map state by setting the map zoomlevel, map bounds and map center
  *
  * @param {Array} markers The new markers to add to the clusterer
  *
  * @returns {void}
  */
	handleMapState: function handleMapState(markers) {
		if (this.map !== null) {
			if (this.moduleOptions.bounds !== null && this.moduleOptions.showAllMarkers) {
				this.setMapCenter(this.moduleOptions.bounds.getCenter());
				this.setMapBounds(this.moduleOptions.bounds);
				this.setMarkersInClusterer(markers);
			} else if (this.moduleOptions.center !== null) {
				this.setMapCenter(this.moduleOptions.center);
				this.setMapZoomLevel(this.moduleOptions.zoomLevel);
			} else {
				this.setMapCenter(this.moduleOptions.initialCenter);
				this.setMapZoomLevel(this.moduleOptions.initialZoomLevel);
			}
		}
	},


	/**
  * Initialize the component
  *
  * @returns {void}
  */
	initialize: function initialize() {
		var _this2 = this;

		this.googleMapsApiLoadedPromise = this.loadGoogleMapsApiPromise();
		this.richMarkerLibraryLoadedPromise = this.loadRichMarkerLibraryPromise();
		this.InfoBoxLibraryLoadedPromise = this.loadInfoBoxLibraryPromise();
		this.MarkerClustererLibraryLoadedPromise = this.loadMarkerClustererLibraryPromise();

		this.librariesLoadedPromise = Promise.all([this.richMarkerLibraryLoadedPromise, this.InfoBoxLibraryLoadedPromise, this.MarkerClustererLibraryLoadedPromise]);

		this.libraryFunctionsExistPromise = this.checkForFunctionExistence(['RichMarker', 'InfoBox', 'MarkerClusterer']);

		this.mapReadyPromise = Promise.all([this.googleMapsApiLoadedPromise, this.librariesLoadedPromise, this.libraryFunctionsExistPromise]);

		this.googleMapsApiLoadedPromise.then(function () {
			_this2.initializeMap();
			_this2.initializeMapEventHandler();
		});

		this.mapReadyPromise.then(function () {
			_this2.initializeMarkerClusterer();
			_this2.renderMarkers(_this2.addresses);
		});
	},


	/**
  * Initialize the map after the library was loaded
  *
  * Please note: This method get's extended in the decorator
  * @returns {void}
  */
	initializeMap: function initializeMap() {
		var latLng = {
			lat: this.moduleOptions.initialCenter.lat,
			lng: this.moduleOptions.initialCenter.lng
		};

		// store center for further usage
		this.moduleOptions.center = latLng;

		$.extend(this.mapOptions, {
			zoom: this.moduleOptions.initialZoomLevel,
			center: latLng
		});

		var styledMapType = new this.googleMaps.StyledMapType(this.customMapStyles, { name: 'Styled Map' });

		if (this.$mapContainer.length > 0) {
			this.map = new this.googleMaps.Map(this.$mapContainer[0], this.mapOptions);

			this.map.mapTypes.set('styled_map', styledMapType);
			this.map.setMapTypeId('styled_map');
		}
	},


	/**
  * Initialize event handlers around the map
  *
  * @returns {void}
  */
	initializeMapEventHandler: function initializeMapEventHandler() {
		var _this3 = this;

		var mod = this; // eslint-disable-line consistent-this

		this.googleMaps.event.addDomListener(window, 'resize', function () {
			_this3.handleMapState(_this3.markers);
		});

		this.googleMaps.event.addListener(this.map, 'zoom_changed', function () {
			if (mod.map.getZoom() < mod.moduleOptions.minimalZoomLevel) {
				mod.setMapZoomLevel(mod.moduleOptions.minimalZoomLevel);
			}
		});
	},


	/**
  * Initialize the markerClusterer
  * For reference, see https://github.com/googlemaps/v3-utility-library/tree/master/markerclustererplus
  *
  * @returns {void}
  */
	initializeMarkerClusterer: function initializeMarkerClusterer() {
		// we initialize the markerClusterer and set the markers later
		// eslint-disable-next-line no-undef
		this.markerClusterer = new MarkerClusterer(this.map, [], this.clustererOptions);
	},


	/**
  * Start loading the google maps api if it is not already defined on the window and return a promise
  *
  * @returns {Promise} A promise which get's resolved when loading of the google maps api has finished
  */
	loadGoogleMapsApiPromise: function loadGoogleMapsApiPromise() {
		var _this4 = this;

		return new Promise(function (resolve) {
			// check if google has already been set on the window object
			if (_typeof(_this4.google) !== 'object' || _typeof(_this4.google.maps) !== 'object') {

				// add document listener for initializing loading google maps which resolves the promise
				$(document).on('google-maps-api-is-loaded', function (event, eventData) {
					$(document).off('google-maps-api-is-loaded');

					_this4.google = eventData.google;
					_this4.googleMaps = eventData.google.maps;

					resolve();
				});

				// actually start loading of google maps
				$.fn.loadScript(_this4.googleMapsApiUrl);
			} else {
				resolve();
			}
		});
	},


	/**
  * Start loading the richMarker library and return a promise
  *
  * @returns {Promise} A promise which get's resolved when loading of the richMarker library has finished
  */
	loadRichMarkerLibraryPromise: function loadRichMarkerLibraryPromise() {
		var _this5 = this;

		return this.googleMapsApiLoadedPromise.then(function () {
			return new Promise(function (resolve) {
				$.fn.loadScript(_this5.richMarkerLibraryUrl, resolve.bind(_this5));
			});
		});
	},


	/**
  * Start loading the infoBox library and return a promise
  *
  * @returns {Promise} A promise which get's resolved when loading of the infoBox library has finished
  */
	loadInfoBoxLibraryPromise: function loadInfoBoxLibraryPromise() {
		var _this6 = this;

		return this.googleMapsApiLoadedPromise.then(function () {
			return new Promise(function (resolve) {
				$.fn.loadScript(_this6.infoBoxLibraryUrl, resolve.bind(_this6));
			});
		});
	},


	/**
  * Start loading the markerClusterer library and return a promise
  *
  * @returns {Promise} A promise which get's resolved when loading of the markerClusterer library has finished
  */
	loadMarkerClustererLibraryPromise: function loadMarkerClustererLibraryPromise() {
		var _this7 = this;

		return this.googleMapsApiLoadedPromise.then(function () {
			return new Promise(function (resolve) {
				$.fn.loadScript(_this7.markerClustererLibraryUrl, resolve.bind(_this7));
			});
		});
	},


	/**
  * Renders the current user location as blue marker
  *
  * @param {Object} location The google maps location object
  * @param {number} locationId The location id for easier handling
  * @param {Object} $markerClone The clone of the marker markup
  * @returns {Object} The rendered marker
  */
	renderMarker: function renderMarker(location, locationId, $markerClone) {
		// eslint-disable-next-line no-undef
		var marker = new RichMarker({
			map: this.map,
			position: location,
			draggable: false,
			flat: true,
			// eslint-disable-next-line no-undef
			anchor: RichMarkerPosition.BOTTOM,
			content: $markerClone[0]
		});

		// locationId comes as a string from the backend
		marker.locationId = parseInt(locationId, 10);

		return marker;
	},


	/**
  * Render all the markers
  *
  * @param {Object} locations The locations to render the markers for
  * @returns {void}
  */
	renderMarkers: function renderMarkers(locations) {
		var _this8 = this;

		if (locations.length > 0) {
			$.each(locations, function (index, location) {

				if (!$.isEmptyObject(location.coordinates)) {
					var markerLocation = new _this8.googleMaps.LatLng(location.coordinates.lat, location.coordinates.lng);

					var $markerClone = _this8.$markerContent.clone();
					var marker = _this8.renderMarker(markerLocation, location.id, $markerClone);

					_this8.addMarkerEvents(marker);

					_this8.markers.push(marker);

					if (_this8.locations.length === 1) {
						// if we have just one location, we set the map center to that location
						_this8.moduleOptions.center = markerLocation;
					} else {
						// otherwise we extend the map bounds object with that location
						if (_this8.moduleOptions.bounds === null) {
							// if the bounds object is null, we create it
							_this8.moduleOptions.bounds = new _this8.googleMaps.LatLngBounds();
						}

						_this8.moduleOptions.bounds.extend(markerLocation);
					}
				}
			});

			this.handleMapState(this.markers);
		}
	},


	/**
  * Set the map bounds
  *
  * @param {Object} bounds The new bounds object
  * @returns {void}
  */
	setMapBounds: function setMapBounds(bounds) {
		var _this9 = this;

		if (this.map !== null) {
			// temporary set max map zoom to prevent to zoom in too much when only having a few locations
			this.map.setOptions({ maxZoom: 14 });
			this.map.fitBounds(bounds);

			// reset max map zoom and remove event listener
			var event = this.googleMaps.event.addListener(this.map, 'idle', function () {
				_this9.map.setOptions({ maxZoom: null });
				_this9.googleMaps.event.removeListener(event);
			});
		}
	},


	/**
  * Set the map center
  *
  * @param {Object} mapCenter The new map center
  * @returns {void}
  */
	setMapCenter: function setMapCenter(mapCenter) {
		if (this.map !== null) {
			this.map.panTo(mapCenter);
		}
	},


	/**
  * Set the map zoom level
  *
  * @param {Object} zoomLevel The new map zoom level
  * @returns {void}
  */
	setMapZoomLevel: function setMapZoomLevel(zoomLevel) {
		if (this.map !== null) {
			this.map.setZoom(zoomLevel);
		}
	},


	/**
  * Set the available markers in the markerClusterer
  *
  * @param {Array} markers The new markers to add to the clusterer
  * @returns {void}
  */
	setMarkersInClusterer: function setMarkersInClusterer(markers) {
		if (this.markerClusterer !== null && markers.length > 0) {
			this.markerClusterer.addMarkers(markers);
			this.markerClusterer.repaint();
		}
	},


	/**
  * Show the info box with the teaser data provided
  *
  * @param {Object} marker The marker to show the info box
  * @param {Object} locationData The teaser data
  * @returns {void}
  */
	showInfoBox: function showInfoBox(marker, locationData) {
		var _this10 = this;

		var location = {
			lat: marker.position.lat(),
			lng: marker.position.lng()
		};

		var $infoBoxContent = $(this.infoBoxTemplate(locationData));

		// close possible previous instance of infoBox
		this.closeInfoBox();

		var infoBoxOptions = {
			closeBoxURL: '',
			content: $infoBoxContent[0],
			maxWidth: this.infoBoxWidth,
			alignBottom: true,
			pixelOffset: new this.googleMaps.Size(-(this.infoBoxWidth / 2), -(this.markerHeight + this.infoBoxOffset)),
			position: location
		};

		// center map to the clicked marker
		this.setMapCenter(location);

		// create new instance of the infoBox
		// eslint-disable-next-line no-undef
		this.infoBox = new InfoBox(infoBoxOptions);

		// we can only add the map click listener on domready because otherwise the click to open the infoBox
		// gets eaten by the click listener to close it again
		this.infoBox.addListener('domready', function () {
			// add map click listener to close the marker again
			_this10.mapClickListener = _this10.googleMaps.event.addListener(_this10.map, 'click', _this10.closeInfoBox.bind(_this10));
		});

		// open the infoBox
		this.infoBox.open(this.map, marker);

		// store the currently active marker to remove the active class later
		this.activeMarker = marker;
	},


	/**
  * Toggle the active class on the given marker
  *
  * @param {Object} marker The marker to toggle the active class
  * @returns {void}
  */
	toggleMapMarkerActiveClass: function toggleMapMarkerActiveClass(marker) {
		$(marker.content).toggleClass(this._stateClasses.markerActive);
	},


	/**
  * Toggle the mouseover class on the given marker
  *
  * @param {Object} marker The marker to toggle the mouseover class
  * @returns {void}
  */
	toggleMapMarkerMouseOverClass: function toggleMapMarkerMouseOverClass(marker) {
		$(marker.content).toggleClass(this._stateClasses.markerMouseOver);
	},


	/**
  * Click event when the user clicked on a marker
  *
  * @param {Object} marker The marker which was clicked on
  * @returns {void}
  */
	onClickLocationMarker: function onClickLocationMarker(marker) {
		var locationData = this.locations.find(function (location) {
			// location.id comes as a string from the backend
			return parseInt(location.id, 10) === marker.locationId;
		});

		this.toggleMapMarkerActiveClass(marker);
		this.showInfoBox(marker, locationData);
	},


	/**
  * Event when the displayed markers should be filtered (used for full text search)
  *
  * @param {Object} eventData The event data
  * @returns {void}
  */
	onFilterMapData: function onFilterMapData(eventData) {
		var _this11 = this;

		this.mapReadyPromise.then(function () {

			_this11.closeInfoBox();
			_this11.destroyMarkers();

			if (eventData.showAll) {
				_this11.renderMarkers(_this11.locations);
			} else {
				var locationsToShow = [];

				// afterwards render the ones matching to a visible result in the list below
				$.each(eventData.visibleResults, function (index, resultIdString) {
					// resultIdString contains "index-xx"
					var resultId = parseInt(resultIdString.substring(6), 10);

					var matchingLocation = _this11.locations.find(function (location) {
						// location.id comes as a string from the backend
						return parseInt(location.id, 10) === resultId;
					});

					locationsToShow.push(matchingLocation);
				});

				_this11.renderMarkers(locationsToShow);
			}
		});
	}
});

/**
 * Event from the google maps api directly when the loading has been completed
 *
 * Needs to be outside our terrific context to work correctly
 *
 * @returns {void}
 */
// eslint-disable-next-line no-unused-vars
var onGoogleMapsApiLoaded = function onGoogleMapsApiLoaded() {
	$(document).trigger('google-maps-api-is-loaded', {
		google: window.google
	});
};